import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { faqs } from '../../data/mock';
import { useInView } from '../../hooks/useInView';
import { HelpCircle } from 'lucide-react';

export const FAQSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section className="py-20 lg:py-28 bg-[hsl(210,20%,98%)]" ref={ref}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className={`text-center mb-12 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="section-divider" />
            <span className="text-sm font-semibold text-ind-red-600 uppercase tracking-wider">FAQ</span>
            <div className="section-divider" />
          </div>
          <h2 className="font-heading font-extrabold text-navy-950 text-3xl lg:text-4xl mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-navy-500 text-base">
            Common questions about our industrial hose and safety products.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className={`${isInView ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`faq-${idx}`}
                className="bg-white border border-navy-100 rounded-xl px-6 overflow-hidden data-[state=open]:border-ind-red-200 data-[state=open]:shadow-sm"
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-navy-900 text-sm hover:text-ind-red-600 py-5 hover:no-underline [&[data-state=open]]:text-ind-red-600">
                  <div className="flex items-center gap-3">
                    <HelpCircle className="w-4 h-4 text-navy-400 flex-shrink-0" />
                    {faq.question}
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-sm text-navy-600 leading-relaxed pb-5 pl-7">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
